const DefaultCategoryCookies = {
  C0005: [
    'fs_uid',
    'PROD_UserID',
    '_ga',
    '_fs_tab_id',
    'PROD_isPunchout',
    'fs_lua',
    '_ga_xxxxxxxxxx',
    '_uetsid',
    'fs_csrftoken',
    '_uetvid',
    'PROD_UnknownUserKey',
    'fs_cid',
    'fireGAEvent',
    'VISITOR_INFO1_LIVE',
    'npst_cookie',
    'npstrackersessions',
    'same95722',
    'test_cookie'
  ],
  C0002: [
    'ext_trk',
    '_ga_xxxxxxxxxx',
    '_clsk',
    '_uetvid',
    '_clck',
    'p.ud.2048.0.._1'
  ],
  C0004: [
    '_uetsid',
    '_gcl_au',
    '__Secure-xxxxxxx',
    'VISITOR_PRIVACY_METADATA',
    'YSC',
    'SRM_B',
    'MR',
    'bcookie',
    'lidc',
    'li_gc',
    'muc_ads',
    '__cf_bm',
    'personalization_id',
    '__cf_bm',
    'MSPTC',
    'MUID',
    'ar_debug',
    'receive-cookie-deprecation',
    'IDE'
  ],
  C0003: [
    'corporatePageviewCount',
    'PROD_Authenticated',
    '_clsk',
    '_clck',
    'CLID',
    'MR',
    'ANONCHK',
    'SM',
    'MUID'
  ]
}

const deleteCookie = (name, domain) => {
  const path = '/' // always using root path
  let cookieString = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}; SameSite=Lax`
  if (domain) {
    cookieString += `; domain=${domain}`
  }
  document.cookie = cookieString
}

export default function deleteCookiesByOTCategory() {
  let categoryCookies = {}
  let activeGroups = ''
  if (typeof OneTrust !== 'undefined') {
    const oneTrustData = OneTrust.GetDomainData()
    oneTrustData.Groups.forEach((group) => {
      const categoryId = group.CustomGroupId
      const cookies = group.Cookies?.map((c) => c.Name).filter(Boolean) || []
      if (cookies.length) {
        categoryCookies[categoryId] = cookies
      }
    })

    // Get active group list as a string like ",C0001,C0002,"
    activeGroups =
      typeof OnetrustActiveGroups !== 'undefined' ? OnetrustActiveGroups : ''
  } else {
    categoryCookies = DefaultCategoryCookies
  }

  Object.entries(categoryCookies).forEach(([category, cookieNames]) => {
    const isEnabled = activeGroups.includes(category)
    if (!isEnabled) {
      cookieNames.forEach((cookieName) => {
        deleteCookie(cookieName)
        deleteCookie(cookieName, window.location.hostname)
        deleteCookie(cookieName, '.swagelok.com')
      })
    }
  })
}
